module.exports = __webpack_public_path__ + "img/face-frown.2c465524.svg";